import { Loader } from "@googlemaps/js-api-loader";
import MarkerClusterer from '@googlemaps/markerclustererplus';
import { featureCollection } from '@turf/helpers';
import union from '@turf/union';
import jQuery from 'jquery';
import _ from 'underscore';
import { getJSON } from "./common";
import { displayDirections } from './directions';

const MARKER_ICON_SCALE = 5.5;

export const MODE_DEPARTMENTS = 1;
export const MODE_CITIES_GROUPS = 2;
export const MODE_REMPLACEMENT_AREAS = 3;

const loader = new Loader({
  apiKey: googleApiKey,
  version: "weekly",
  region: 'FR',
  mapIds: [googleMapId],
});

const cityIndexMarkers = {};
const pasLoinDeParis = { lat: 48.8, lng: 2.1 };
const schools = {};

var streetViewService;
var map;
var cluster;
var selectedMarker = undefined;

const config = {
  mode: MODE_DEPARTMENTS,
  dnp: [],
  rep: undefined,
  state: undefined,
};

loader.load().then(() => {
  streetViewService = new google.maps.StreetViewService();
  initMap();
});

window.addEventListener('popstate', function (event) {
  // console.log(event.state);
  applyState(event.state);
});

function styleDepartment(feature, mode) {
  return {
    fillColor: feature.getProperty('color'),
    fillOpacity: mode === MODE_DEPARTMENTS ? 0.3 : 0,
    strokeColor: '#999',
    strokeOpacity: 1,
    strokeWeight: 5,
    zIndex: 2,
    visible: true,//mode === MODE_DEPARTMENTS,
    clickable: false,
  };
}

function styleReplacementArea(feature, mode) {
  return {
    fillColor: feature.getProperty('color'),
    fillOpacity: 0.3,
    strokeColor: feature.getProperty('color'),
    strokeOpacity: 1,
    strokeWeight: 3,
    zIndex: 3,
    visible: mode === MODE_REMPLACEMENT_AREAS,
    clickable: true,
  };
}

function styleCity(feature, mode) {
  return {
    fillColor: feature.getProperty('color'),
    fillOpacity: 0,
    strokeColor: feature.getProperty('color'),
    strokeOpacity: 0.3,
    strokeWeight: 2,
    zIndex: 3,
    visible: mode === MODE_CITIES_GROUPS,
    clickable: false,
  };
}

function styleCitiesGroup(feature, mode) {
  return {
    fillColor: feature.getProperty('color'),
    fillOpacity: 0.3,
    strokeColor: feature.getProperty('color'),
    strokeOpacity: 1,
    strokeWeight: 3,
    zIndex: 4,
    visible: mode === MODE_CITIES_GROUPS,
    clickable: true,
  };
}

const styleFunctions = {
  'suv_department': styleDepartment,
  'suv_city': styleCity,
  'suv_cities_group': styleCitiesGroup,
  'suv_replacement_area': styleReplacementArea,
}

function mapStyle(feature) {
  const featureType = feature.getProperty('type');
  if (styleFunctions[featureType]) {
    //     console.debug(featureType);
    return styleFunctions[featureType](feature, config.mode);
  } else {
    return {
      visible: false,
    }
  }
}

export function setInitialState(state) {
  console.log("Initial state received");
  config.state = state;
}

function applyState(state, inital = false) {
  console.log('Applying state');
  console.log(state);
  if (state) {
    document.title = state.title ? `${state.title} - SE UNSA Versailles` : 'SE UNSA Versailles';

    if (state.center && state.zoom) {
      map.setZoom(state.zoom);
      map.panTo(state.center);
    }

    if (state.post_type && state.name) {
      console.log("It's a new state, updating the interface");
      clearMarkerSelection();

      if (state.post_type === 'suv_school') {
        selectedMarker = schools[state.name].marker;
        selectedMarker.setIcon({ ...selectedMarker.icon, scale: MARKER_ICON_SCALE * 2 });
      }

      jQuery("#details-content").html('<div class="mt-6 mx-3"><progress class="progress is-large is-info"></progress></div>');
      jQuery("#details-content").load(`/${state.post_type.replace('suv_', '').replace('_', '-')}/${state.name}/?ajax=true`, function () {
        if (state.post_type === 'suv_school') {
          displayDirections('#nearby', selectedMarker.position.lat(), selectedMarker.position.lng());
        }
      });
      jQuery('#details').show();
    } else if (!inital) {
      hideDetails();
    }
  }
}

function pushState(state) {
  const contentUrl = computeStateUrl(state);
  const newState = { ...(state ?? {}), url: contentUrl };
  if (!history.state || contentUrl !== history.state.url) {
    console.log('Pushing state');
    history.pushState(newState, state.title, contentUrl);
  }

  if (!config.state || contentUrl !== config.state.url) {
    config.state = newState;
    applyState(config.state);
  }
}

function computeStateUrl(state) {
  let contentUrl = '/';
  if (state.post_type && state.name) {
    contentUrl = `/${state.post_type.replace('suv_', '').replace('_', '-')}/${state.name}/`;
  }
  if (state.center && state.zoom) {
    contentUrl += `?@=${Math.round(state.center.lat * 10000000) / 10000000},${Math.round(state.center.lng * 10000000) / 10000000},${state.zoom}`;
  }
  return contentUrl;
}

export function setMode(element, mode) {
  config.mode = mode;
  map.data.setStyle(mapStyle);
  for (const city of _.values(cityIndexMarkers)) {
    city.setVisible(mode === MODE_CITIES_GROUPS);
    // city.setMap(mode === MODE_CITIES_GROUPS ? map : null);
  }

  jQuery(element).parents('ul').find('a').removeClass('is-active');
  jQuery(element).addClass('is-active');
}

export function setREPFilter(element, show) {
  config.rep = show;

  refreshClusters();

  jQuery(element).parents('ul').find('a').removeClass('is-active');
  jQuery(element).addClass('is-active');
}

export function toggleDNP(element, dnp) {
  if (dnp === undefined) {
    // Réinitisalisation des filtres
    config.dnp = [];
    jQuery(element).parents('ul').find('a').removeClass('is-active')
  } else if (config.dnp.includes(dnp)) {
    config.dnp = config.dnp.filter(item => item !== dnp);
    jQuery(element).removeClass('is-active');
  } else {
    config.dnp.push(dnp);
    jQuery(element).addClass('is-active');
  }

  // Change state of "All etablishments"
  if (config.dnp.length === 0) {
    jQuery(element).parents('ul').find('a:first').addClass('is-active');
  } else {
    jQuery(element).parents('ul').find('a:first').removeClass('is-active');
  }

  // if (dnp === 'college') {
  //   jQuery('#filter-rep').removeClass('is-hidden');
  // } else {
  //   jQuery('#filter-rep').addClass('is-hidden');
  //   jQuery('#filter-rep ul li a').removeClass('is-active');
  //   jQuery('#filter-rep ul li:first a').addClass('is-active');
  //   config.rep = undefined;
  // }

  refreshClusters();

  // jQuery(element).parents('ul').find('a').removeClass('is-active');
  // jQuery(element).addClass('is-active');
}

export function hideDetails() {
  clearMarkerSelection();
  pushState({ ...(history.state ?? {}), post_type: null, name: null, title: "Carte des établissements" });
  jQuery('#details').hide();
}

function clearMarkerSelection() {
  if (selectedMarker) {
    selectedMarker.setIcon({ ...selectedMarker.icon, scale: MARKER_ICON_SCALE });
  }
}

function refreshClusters() {
  if (!cluster) {
    console.warn('Cluster is not initalized yet');
    return;
  }

  for (const school of _.values(schools)) {
    const visible = (config.dnp.length === 0 || config.dnp.includes(school.value.dnp)) && (school.value.dnp !== 'college' || config.rep === undefined || school.value.rep === config.rep);
    if (visible) {
      cluster.addMarker(school.marker, true);
    } else {
      // Evite les problèmes d'un même marker ajouté plusieurs fois (test de singe)
      while (cluster.removeMarker(school.marker, true));
    }
  }

  cluster.repaint();
}

export function highlightFeature(featureId) {
  if (map) {
    const feature = map.data.getFeatureById(featureId);
    if (feature) {
      map.data.overrideStyle(feature, {
        strokeWeight: 3,
        strokeOpacity: 1,
        fillOpacity: 0.6,
        zIndex: 100,
      });
    }
  }
}

export function revertFeatureStyle(featureId) {
  if (map) {
    const feature = map.data.getFeatureById(featureId);
    if (feature) {
      map.data.revertStyle(feature);
    }
  }
}

export function displayStreetView() {
  if (map && selectedMarker) {

    streetViewService.getPanorama({ location: selectedMarker.position, radius: 200 }, function (data, status) {
      if (status === 'OK') {
        const panorama = map.getStreetView();
        panorama.setPano(data.location.pano);
        panorama.setVisible(true);
        // panorama.setPosition(selectedMarker.position);
      } else {
        console.error("Street View data not found for this location.");
      }
    });
  }
}

async function loadContent(map) {
  jQuery('#loader').show();

  const [citiesGroups, replacementAreas, dnps] = await Promise.all([
    // - Groupement de communes
    getJSON("/wp-json/wp/v2/suv_cities_group?per_page=100"),
    // - Zones de replacement
    getJSON("/wp-json/wp/v2/suv_replacement_area?per_page=100"),
    // - DNP
    getJSON("/wp-json/wp/v2/suv_dnp?per_page=100"),
  ]);

  // - DNP
  const dnpColorsBySlug = {};
  for (const dnp of dnps) {
    dnpColorsBySlug[dnp.slug] = dnp.meta_box.suv_dnp_color && dnp.meta_box.suv_dnp_color.length > 0 ? dnp.meta_box.suv_dnp_color : undefined;
  }

  // - Departments
  const departments = await getJSON("/wp-json/wp/v2/suv_department?per_page=100");
  for (const department of departments) {
    const departmentCityGroups = _.filter(citiesGroups, (citiesGroup) => citiesGroup.suv_department.indexOf(department.id) >= 0);
    const departmentReplacementAreas = _.filter(replacementAreas, (replacementArea) => replacementArea.suv_department.indexOf(department.id) >= 0);

    if (department.meta_box['suv_department_file'] && department.meta_box['suv_department_file'][0]) {
      map.data.loadGeoJson(department.meta_box['suv_department_file'][0].url,
        { idPropertyName: 'code' }, function (features) {
          for (const feature of features) {
            feature.setProperty("type", 'suv_department');
            feature.setProperty("color", department.meta_box['suv_department_color']);
          }
        });
    }

    if (department.meta_box['suv_cities_file'] && department.meta_box['suv_cities_file'][0]) {
      const citiesGeoJSON = await getJSON(department.meta_box['suv_cities_file'][0].url);

      const replacementAreasCitiesFeatures = {};
      const citiesGroupFeatures = {};

      for (const feature of citiesGeoJSON.features) {
        feature.properties.type = 'suv_city';
        feature.properties.slug = feature.properties.code;

        const citiesGroup = _.find(departmentCityGroups, (citiesGroup) => _.some(citiesGroup.meta_box.suv_cities, (city) => city.slug === feature.properties.code));
        if (citiesGroup) {
          const citiesGroupColor = citiesGroup.meta_box.suv_cities_group_color || '#CCC';
          feature.properties.color = citiesGroupColor;

          // const cityIndexInGroup = _.findIndex(citiesGroup.meta_box['suv_cities'], (city) => city.slug === feature.properties.code);
          // const centerOfMass = turf.centerOfMass(feature);
          // const cityMarker = new google.maps.Marker({
          //   position: new google.maps.LatLng(centerOfMass.geometry.coordinates[1], centerOfMass.geometry.coordinates[0]),
          //   map: map,
          //   icon: { path: google.maps.SymbolPath.CIRCLE, scale: 0 },
          //   label: {
          //     color: citiesGroupColor,
          //     fontWeight: 'bold',
          //     text: (cityIndexInGroup + 1).toString(),
          //     fontSize: '16px',
          //   },
          //   visible: false,
          //   clickable: false,
          // });

          // cityIndexMarkers[feature.properties.code] = cityMarker;

          if (!citiesGroupFeatures[citiesGroup.slug]) {
            citiesGroupFeatures[citiesGroup.slug] = { citiesGroup: citiesGroup, features: [] };
          }
          citiesGroupFeatures[citiesGroup.slug].features.push(feature);
        }

        const replacementArea = _.find(departmentReplacementAreas, (replacementArea) => _.some(replacementArea.meta_box.suv_cities, (city) => city.slug === feature.properties.code));
        if (replacementArea) {
          if (!replacementAreasCitiesFeatures[replacementArea.slug]) {
            replacementAreasCitiesFeatures[replacementArea.slug] = { replacementArea: replacementArea, features: [] };
          }
          replacementAreasCitiesFeatures[replacementArea.slug].features.push(feature);
        }
      }

      // - Union des communes pour les zones de remplacement
      for (const replacementAreaCitiesFeaturesKey of _.keys(replacementAreasCitiesFeatures)) {
        const remplacementAreaFeature = replacementAreasCitiesFeatures[replacementAreaCitiesFeaturesKey].features.reduce((prev, cur) => union(prev, cur));
        remplacementAreaFeature.properties = {
          type: 'suv_replacement_area',
          slug: replacementAreaCitiesFeaturesKey,
          color: replacementAreasCitiesFeatures[replacementAreaCitiesFeaturesKey].replacementArea.meta_box.suv_replacement_area_color,
          label: `${replacementAreasCitiesFeatures[replacementAreaCitiesFeaturesKey].replacementArea.title?.rendered} - Zone de replacement`
        };
        map.data.addGeoJson(remplacementAreaFeature, { idPropertyName: 'slug' });
      }

      // Nouvelle collection de features pour les groupement de communes
      for (const citiesGroupFeaturesKey of _.keys(citiesGroupFeatures)) {
        // Feature avec toutes les communes (polygones)
        const citiesGroupFeature = featureCollection(citiesGroupFeatures[citiesGroupFeaturesKey].features);
        map.data.addGeoJson(citiesGroupFeature, { idPropertyName: 'slug' });

        // Union de toutes les features
        const citiesGroupMainFeature = citiesGroupFeatures[citiesGroupFeaturesKey].features.reduce((prev, cur) => union(prev, cur));
        citiesGroupMainFeature.properties = {
          type: 'suv_cities_group',
          slug: citiesGroupFeaturesKey,
          color: citiesGroupFeatures[citiesGroupFeaturesKey].features[0].properties.color,
          label: `${citiesGroupFeatures[citiesGroupFeaturesKey].citiesGroup.title?.rendered} - Groupement de communes`,
        };
        map.data.addGeoJson(citiesGroupMainFeature, { idPropertyName: 'slug' });
      }
    }
  }

  // - PIO
  const data = await getJSON("/wp-json/se-unsa-versailles/v1/poi/");
  console.info('POI received');

  for (const school of data) {
    if (!school.location) {
      console.debug("L'établissement '" + school.slug + "' ne possède pas de localisation");
      continue;
    }

    const schoolMarker = new google.maps.Marker({
      position: school.location,
      // label: school.label,
      icon: {
        path: google.maps.SymbolPath.CIRCLE,
        scale: 5.5,
        strokeWeight: 3,
        fillColor: dnpColorsBySlug[school.dnp] || '#EB6209', //'#ffffff',
        fillOpacity: 0.5,
        strokeColor: dnpColorsBySlug[school.dnp] || '#EB6209',
        strokeOpacity: 1,
      },
      // map: map,
      visible: true,
    });

    schoolMarker.addListener("click", () => pushState({ ...(history.state ?? {}), post_type: 'suv_school', name: school.slug, title: school.label }));

    schools[school.slug] = {
      value: school,
      marker: schoolMarker,
    };
  }

  cluster = new MarkerClusterer(map, _.values(schools).map(school => school.marker), {
    // imagePath: "https://github.com/googlemaps/js-markerclustererplus/raw/main/images/m",
    maxZoom: 12,
    gridSize: 40,
    styles: [
      { width: 30, height: 30, className: "custom-clustericon-1", },
      { width: 40, height: 40, className: "custom-clustericon-2", },
      { width: 50, height: 50, className: "custom-clustericon-3", },
    ],
    clusterClass: "custom-clustericon",
  });

  jQuery('#loader').hide();
}

async function initMap() {
  map = new google.maps.Map(document.getElementById("map"), {
    mapId: googleMapId,
    zoom: 10,
    center: pasLoinDeParis,
    // useStaticMap: true,
    fullscreenControl: false,
  });

  const transitLayer = new google.maps.TransitLayer();
  transitLayer.setMap(map);

  map.data.setStyle(mapStyle);

  map.data.addListener('mouseover', function (event) {
    if (['suv_cities_group', 'suv_replacement_area'].includes(event.feature.getProperty('type'))) {
      map.data.overrideStyle(event.feature, { strokeWeight: 5, zIndex: 100, });
    }
  });
  map.data.addListener('mouseout', function (event) {
    map.data.revertStyle(event.feature);
  });
  map.data.addListener('click', function (event) {
    pushState({ ...(history.state ?? {}), post_type: event.feature.getProperty('type'), name: event.feature.getId(), title: event.feature.getProperty('label') });
  });
  map.addListener('idle', function (event) {
    //     if (history.state) {
    const newState = { ...(history.state ?? {}), center: { lat: map.getCenter().lat(), lng: map.getCenter().lng() }, zoom: map.getZoom() };
    history.replaceState(newState, null, computeStateUrl(newState))
    //     }
  });

  await loadContent(map);

  applyState(config.state, true);
}